import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from '../i18n';
export function UseCaseHotelsPage() {
  const {
    t
  } = useTranslation();
  return <div className="pt-24" data-id="element-914">
      <section className="relative py-24 lg:py-32 overflow-hidden" data-id="element-915">
        <div className="absolute inset-0 overflow-hidden pointer-events-none" data-id="element-916">
          <div className="aurora-blob bg-[#FFB800] w-[600px] h-[600px] top-[-10%] right-[-10%] animate-aurora-1" data-id="element-917"></div>
          <div className="aurora-blob bg-[#FF3CAC] w-[800px] h-[800px] bottom-[-20%] left-[-10%] animate-aurora-2" data-id="element-918"></div>
        </div>
        <div className="max-w-4xl mx-auto px-6 relative z-10 text-center" data-id="element-919">
          <div className="inline-block px-4 py-1.5 rounded-full border border-white/10 bg-white/5 mb-6" data-id="element-920">
            <span className="text-sm font-bold text-gradient uppercase tracking-wider" data-id="element-921">
              {t('useCaseHotels.badge')}
            </span>
          </div>
          <h1 className="text-5xl lg:text-7xl font-bold leading-[1.1] mb-6" data-id="element-922">
            {t('useCaseHotels.heroTitle')}
            <span className="text-gradient" data-id="element-923">
              {t('useCaseHotels.heroTitleHighlight')}
            </span>
          </h1>
          <p className="text-xl text-white/60 mb-10 leading-relaxed max-w-3xl mx-auto" data-id="element-924">
            {t('useCaseHotels.heroDesc')}
          </p>
          <a href="https://calendar.app.google/kAzzsMuwfngdzNZf9" target="_blank" rel="noopener noreferrer" className="inline-block bg-gradient-animated rounded-full px-10 py-5 text-lg font-bold text-white hover:scale-105 transition-transform duration-300 shadow-[0_0_30px_rgba(255,184,0,0.3)]" data-id="element-925">
            {t('useCaseHotels.bookDemo')}
          </a>
        </div>
      </section>

      <section className="py-24 bg-[#0A0A0A] relative z-20 border-t border-white/5" data-id="element-926">
        <div className="max-w-4xl mx-auto px-6" data-id="element-927">
          <h2 className="text-3xl md:text-5xl font-bold mb-16 text-center" data-id="element-928">
            {t('useCaseHotels.challengeTitle')}
          </h2>
          <div className="space-y-6" data-id="element-929">
            {[0, 1, 2].map(idx => <div key={idx} className="flex items-center p-8 bg-[#050505] rounded-2xl border border-white/10" data-id="element-930">
                <div className="w-1.5 h-12 rounded-full bg-white/20 mr-6 shrink-0" data-id="element-931"></div>
                <p className="text-xl text-white/80 font-medium" data-id="element-932">
                  {t(`useCaseHotels.pain${idx}`)}
                </p>
              </div>)}
          </div>
        </div>
      </section>

      <section className="py-24 bg-[#050505] relative z-20 border-t border-white/5" data-id="element-933">
        <div className="max-w-7xl mx-auto px-6" data-id="element-934">
          <h2 className="text-3xl md:text-5xl font-bold mb-16 text-center" data-id="element-935">
            {t('useCaseHotels.solutionTitle')}
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-936">
            <div className="bg-[#0A0A0A] border border-white/10 rounded-3xl p-10 hover:border-white/20 transition-colors" data-id="element-937">
              <h3 className="text-2xl font-bold mb-4 text-gradient" data-id="element-938">
                {t('useCaseHotels.mapTitle')}
              </h3>
              <p className="text-white/60 text-lg leading-relaxed" data-id="element-939">
                {t('useCaseHotels.mapDesc')}
              </p>
            </div>
            <div className="bg-[#0A0A0A] border border-white/10 rounded-3xl p-10 hover:border-white/20 transition-colors" data-id="element-940">
              <h3 className="text-2xl font-bold mb-4 text-gradient" data-id="element-941">
                {t('useCaseHotels.sparkTitle')}
              </h3>
              <p className="text-white/60 text-lg leading-relaxed" data-id="element-942">
                {t('useCaseHotels.sparkDesc')}
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="py-24 bg-[#0A0A0A] relative z-20 border-t border-white/5" data-id="element-943">
        <div className="max-w-4xl mx-auto px-6" data-id="element-944">
          <h2 className="text-3xl md:text-5xl font-bold mb-16 text-center" data-id="element-945">
            {t('useCaseHotels.fitsTitle')}
          </h2>
          <div className="space-y-8" data-id="element-946">
            {[0, 1, 2].map(idx => <div key={idx} className="flex items-center p-6 bg-[#050505] rounded-2xl border border-white/5" data-id="element-947">
                <div className="w-1.5 h-12 rounded-full bg-gradient-animated mr-6 shrink-0" data-id="element-948"></div>
                <p className="text-xl text-white/90 font-medium" data-id="element-949">
                  {t(`useCaseHotels.fit${idx}`)}
                </p>
              </div>)}
          </div>
        </div>
      </section>

      <section className="relative py-32 overflow-hidden bg-[#050505] border-t border-white/5" data-id="element-950">
        <div className="absolute inset-0 overflow-hidden pointer-events-none opacity-50" data-id="element-951">
          <div className="aurora-blob bg-[#CC00FF] w-[400px] h-[400px] top-[10%] left-[20%] animate-aurora-2" data-id="element-952"></div>
          <div className="aurora-blob bg-[#2563EB] w-[500px] h-[500px] bottom-[10%] right-[20%] animate-aurora-1" style={{
          animationDirection: 'reverse'
        }} data-id="element-953"></div>
        </div>
        <div className="relative z-10 max-w-4xl mx-auto px-6 text-center" data-id="element-954">
          <h2 className="text-4xl md:text-6xl font-bold mb-12" data-id="element-955">
            {t('useCaseHotels.ctaTitle')}
            <span className="text-gradient" data-id="element-956">
              {t('useCaseHotels.ctaHighlight')}
            </span>
          </h2>
          <a href="https://calendar.app.google/kAzzsMuwfngdzNZf9" target="_blank" rel="noopener noreferrer" className="inline-block bg-gradient-animated rounded-full px-10 py-5 text-lg font-bold text-white hover:scale-105 transition-transform duration-300 shadow-[0_0_40px_rgba(0,229,255,0.3)]" data-id="element-957">
            {t('useCaseHotels.ctaCta')}
          </a>
        </div>
      </section>
    </div>;
}